'use client'

import {type ReactNode, useEffect, useState} from 'react'
import SplashScreen from '@/components/screens/SplashScreen'

export default function SplashScreenWrapper({children}: { children: ReactNode }) {
    const [showSplash, setShowSplash] = useState(true)

    useEffect(() => {
        if (!process.env.NEXT_PUBLIC_SPLASH_SCREEN_DURATION) return
        setTimeout(() => setShowSplash(false), parseInt(process.env.NEXT_PUBLIC_SPLASH_SCREEN_DURATION, 10))
    }, [])

    return showSplash && process.env.NEXT_PUBLIC_SPLASH_SCREEN_DURATION
        ? <SplashScreen isBrowser={false}/>
        : <>{children}</>
}
